// Serviço de Categorias
import apiClient from './client';
import { endpoints } from './endpoints';
import type { Category } from '@/types';

interface CategoryPayload {
  imageUrl?: string;
  image_url?: string;
  [key: string]: unknown;
}

export const categoryService = {
  async list(includeChildren = false): Promise<Category[] | unknown> {
    const response = await apiClient.get(endpoints.categories.list, {
      params: { includeChildren: String(includeChildren) },
    });
    return response.data;
  },
  async getBySlug(slug: string): Promise<Category | unknown> {
    const response = await apiClient.get(endpoints.categories.get(slug));
    return response.data;
  },
  async getById(id: string): Promise<Category | unknown> {
    const response = await apiClient.get(endpoints.categories.getById(id));
    return response.data;
  },
  async getWithChildren(id: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.categories.getById(id));
    return response.data;
  },
  async getChildren(id: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.categories.getChildren(id));
    return response.data;
  },
  normalizeCategoryPayload(data: CategoryPayload): CategoryPayload & { image_url?: string } {
    const payload = { ...data };
    if (payload.imageUrl !== undefined) (payload as Record<string, unknown>).image_url = payload.imageUrl;
    return payload as CategoryPayload & { image_url?: string };
  },
  async create(categoryData: CategoryPayload): Promise<unknown> {
    const payload = categoryService.normalizeCategoryPayload(categoryData);
    const response = await apiClient.post(endpoints.categories.create, payload);
    return response.data;
  },
  async update(id: string, categoryData: CategoryPayload): Promise<unknown> {
    const payload = categoryService.normalizeCategoryPayload(categoryData);
    const response = await apiClient.put(endpoints.categories.update(id), payload);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.categories.delete(id));
    return response.data;
  },
};
